<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">    
    <v-row>
      <v-col
        xs="12"
        md="6"
      >
      <v-menu
          v-model="schedule_date_menu"
          :close-on-content-click="false"
          full-width
          max-width="290"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="formatedScheduleDate"
              clearable
              label="Data de agendamento"
              @click:clear="schedule_date = null"
              readonly
              prepend-icon="event"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="schedule_date"
            required
            :min="minScheduleDate"
            @change="schedule_date_menu = false"            
            locale="pt-br"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        xs="12"
        md="6"
      >
      <v-select
          v-model="status"
          required
          :items="[
              {
              text: 'Aguardando Contato',
              value: 1,
              },
              {
              text: 'Contactado por WhatsApp',
              value: 2,
              },
              {
              text: 'Contactado por Telefone',
              value: 3,
              },
              {
              text: 'Contactado por SMS',
              value: 4,
              },
              {
              text: 'Contactado por E-mail',
              value: 5,
              },
              {
              text: 'Agendado',
              value: 6,
              },
              {
              text: 'Sem WhatsApp',
              value: 7,
              },
              {
              text: 'Não Responde',
              value: 8,
              },
              {
              text: 'Não Comprou',
              value: 9,
              },
              {
              text: 'Rastreio Enviado',
              value: 10,
              },
          ]"          
          label="Status"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs="12">
        <v-textarea
          solo
          name="observations"
          v-model="observations"
          label="Observações"
          required
          no-resize
        ></v-textarea>
      </v-col>
    </v-row>
    <v-btn
      :disabled="!valid"
      color="success"
      type="submit"
    >
      {{ this.selected ? 'Atualizar' : 'Cadastrar'}}
    </v-btn>      
  </v-form>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    selected: {
      type: Object,
      default() {
        return {};
      }
    },
    subattending: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  name: 'Form',
  computed: {
    formatedScheduleDate() {
      return this.schedule_date ? moment(this.schedule_date).format("DD/MM/YYYY") : ''
    },
    minScheduleDate() {
      return moment().toISOString();
    }
  },
  methods: {
    submit(e) {
      e.preventDefault();
      const {status, observations, schedule_date} = this;
      if (this.$refs.form.validate()) {        
        const data = {    
          status,
          observations,
          schedule_date,
          subattending: this.subattending.id
        };
        
        if (this.selected) {
          data.id = this.selected.id;
          this.$emit('close');
        }

        this.$store.dispatch('createSubAttendingSchedule', { data });
        this.$emit('close', true);
      }
    },
    handleChangeStatus() {
      return '';
    }
  },
  mounted() {
    console.log(this.subattending);
  },
  data () {    
    return {
      schedule_date_menu: this.selected ? this.selected.schedule_date_menu : false,
      schedule_date: this.selected ? this.selected.next_contact_at.split(" ")[0] : null,
      status: this.selected ? this.selected.contact_status_id : null,
      valid: this.selected ? this.selected.valid : false,
      observations: this.selected ? this.selected.observations : '',
    }
  }
}
</script>

<style lang="css" scoped>
img {
  max-width: 200px;
  height: auto;
}
</style>